import React from "react";
import { useState } from "react";
import { ISelectOption } from "../forms/util";
import { ReactComponent as OperationalFormsIcon } from "assets/icons/operational-forms.svg";
import './OperationalForms.css';
import { Link } from "react-router-dom";

import {
    ChevronRight as RightIcon,
    ExpandMore as DownIcon
} from '@mui/icons-material';
import { operationalFormsHomePage, trainEventRecord, trainEventRecordOverview, trainEventRecordSection } from "./TrainEventRecord/TrainEventRecordPageSelector";

interface OperationalFormsSidebarProps {
    selectedPage: ISelectOption
}

export const OperationalFormsSidebar = (props: OperationalFormsSidebarProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);

    return (
        <>
            <div className="of-sidebar of-sidebar-nav">
                <div className="of-sidebar-title">
                    <OperationalFormsIcon />
                    <div className="d-inline-block">Operational Forms</div>
                </div>

                <div className="of-sidebar-item">
                    <Link
                        to={operationalFormsHomePage.getRoute().path as string}
                        className={`${currentSelection == operationalFormsHomePage ? 'of-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{operationalFormsHomePage.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                <div className="of-sidebar-item">
                    <Link
                        to={trainEventRecordSection.getRoute().path as string}
                        className={`${currentSelection == trainEventRecordSection || currentSelection.subitem ? 'of-nav-selected' : ''}`}>
                        <div className="row">
                            <div className="col-11">{trainEventRecordSection.label}</div>
                            <div className="col-1"><DownIcon className="of-nav-display-unselected" /></div>
                        </div>
                    </Link>
                </div>

                {currentSelection.subitem &&
                    <>
                        <div className="of-sidebar-item of-sidebar-subitem">
                            <Link
                                to={trainEventRecordOverview.getRoute().path as string}
                                className={`${currentSelection == trainEventRecordOverview ? 'of-nav-selected ' : ''}of-nav-subitem`}>
                                <div className="row">
                                    <div className="col-11">{trainEventRecordOverview.label}</div>
                                    <div className="col-1"><RightIcon /></div>
                                </div>
                            </Link>
                        </div>

                        <div className="of-sidebar-item of-sidebar-subitem">
                            <Link
                                to={trainEventRecord.getRoute().path as string}
                                className={`${currentSelection == trainEventRecord ? 'of-nav-selected ' : ''}of-nav-subitem`}>
                                <div className="row">
                                    <div className="col-11">{trainEventRecord.label}</div>
                                    <div className="col-1"><RightIcon /></div>
                                </div>
                            </Link>
                        </div>

                    </>
                }
            </div>
        </>
    );
};